/**
 * Local Trellis catalog (Feeney task 1e).
 *
 * Merged into GET /products results so they appear in Add Trellis without
 * waiting for admin uploads. Once the same models are published on the
 * backend (matching `id`), the local copies are skipped.
 *
 * Models: assets/models/trellis/*.obj|.mtl
 * Previews: assets/images/trellis/*.png
 *
 * Kit sizes (inches → cm): Diamond 64×32, Fan 62×54, Rectangular Grid 69×35.
 * Non-resizable; wallInteraction mountable (no wall cutout).
 */
export interface ITrellisProduct {
  id: string;
  application: string;
  description: string;
  left_menu_alias: string;
  productType: 'Trellis';
  productGroup: string;
  wallInteraction: 'mountable';
  height: number;
  length: number;
  width: number;
  modelObj: string;
  modelMtl: string;
  localProductImg: string;
  productImg: string;
  localAsset: boolean;
}

const MODEL_DIR = 'trellis/';
const IMG_DIR = '/assets/images/trellis/';
const IN = 2.54;

function trellis(
  id: string,
  key: string,
  alias: string,
  description: string,
  dimsInches: { height: number; length: number; width?: number }
): ITrellisProduct {
  return {
    id,
    application: 'Home',
    description,
    left_menu_alias: alias,
    productType: 'Trellis',
    productGroup: 'Trellis',
    wallInteraction: 'mountable',
    height: dimsInches.height * IN,
    length: dimsInches.length * IN,
    // Thin depth so width/2 offset seats the back face on the wall.
    width: dimsInches.width != null ? dimsInches.width * IN : 2.5,
    modelObj: `${MODEL_DIR}${key}.obj`,
    modelMtl: `${MODEL_DIR}${key}.mtl`,
    localProductImg: `${IMG_DIR}${key}.png`,
    productImg: `${key}.png`,
    localAsset: true
  };
}

export const LOCAL_TRELLIS: ITrellisProduct[] = [
  trellis(
    'local_trellis_diamond_lattice',
    'diamond_lattice',
    'Diamond Lattice',
    'Diamond Lattice Trellis',
    { height: 64, length: 32 }
  ),
  trellis(
    'local_trellis_fan',
    'fan',
    'Fan',
    'Fan Trellis',
    { height: 62, length: 54 }
  ),
  trellis(
    'local_trellis_rectangular_grid',
    'rectangular_grid',
    'Rectangular Grid',
    'Rectangular Grid Trellis',
    { height: 69, length: 35 }
  )
];

export function mergeLocalTrellis(apiProducts: any[]): any[] {
  const existingIds = new Set((apiProducts || []).map(p => p && p.id));
  const extras = LOCAL_TRELLIS.filter(p => !existingIds.has(p.id));
  return [...(apiProducts || []), ...extras];
}



// WEBPACK FOOTER //
// ./src/app/models/2d3d/trellis.config.ts